import { compileHtmlElementToIR, compileHtmlToIR, layoutFromIR, registerHtmlTagCompiler } from "../core";
import { dark } from "../theme";
import { type LayoutFn, type Theme } from "../termui";
import type { MarkdownThemeOverrides } from "./types";
import type { TermAction } from "../core";
import type { HtmlTagCompiler } from "../core";

export type HtmlAction = TermAction;

export type HtmlRenderOptions = {
  theme?: Theme;
  overrides?: MarkdownThemeOverrides;
  onAction?: (action: HtmlAction) => void;
};

export type { HtmlTagCompiler };

export function registerHtmlCompiler(tag: string, compiler: HtmlTagCompiler): void {
  registerHtmlTagCompiler(tag, compiler);
}

export function fromHtmlElement(
  root: Element,
  opts?: HtmlRenderOptions,
): LayoutFn {
  const theme = opts?.theme ?? dark;
  const ir = compileHtmlElementToIR(root, {
    theme,
    overrides: opts?.overrides,
  });
  return layoutFromIR(ir, {
    theme,
    overrides: opts?.overrides,
    onAction: opts?.onAction,
  });
}

export function fromHtml(
  html: string,
  opts?: HtmlRenderOptions,
): LayoutFn {
  const theme = opts?.theme ?? dark;

  if (typeof DOMParser === "undefined") {
    throw new Error("DOMParser is unavailable; fromHtml requires a DOM environment.");
  }

  const ir = compileHtmlToIR(html, {
    theme,
    overrides: opts?.overrides,
  });
  return layoutFromIR(ir, {
    theme,
    overrides: opts?.overrides,
    onAction: opts?.onAction,
  });
}
